module.exports = __webpack_public_path__ + "media/src/images/giftee_for_business-12f6e823ee6eb2ba691428b0ebb2cd8f.png";